<template>
  <div class="navscroll" :style="{ height: scrollerHeight }">
    <ul class="nav metismenu" id="side-menu" v-if="sidebar.opened">
      <li class="nav-header">
        <div class="dropdown profile-element">
          <span>
            <img alt="image" class="img-circle" style="width: 48px; height: 48px; object-fill: cover" src="@/assets/logo.png" />
          </span>
          <a class="nodecorationlink" href="javascript:;">
            <span class="clear">
              <span class="block m-t-xs">
                <div v-if="adminUnitName != ' '">
                  <strong class="font-bold">{{ adminUnitName }}</strong>
                </div>
              </span>
              <span class="block m-t-xs">
                <strong class="font-bold">{{ adminRoleName }}</strong>
              </span>
              <el-dropdown>
                <span class="el-dropdown-link">
                  {{ adminName
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <el-link :underline="false" icon="el-icon-edit" @click.prevent.stop="dialogFormVisible = true">修改密码</el-link></el-dropdown-item>
                  <el-dropdown-item :divided="true">
                    <el-link :underline="false" icon="el-icon-s-unfold" @click.prevent.stop="logOut()">退出登录</el-link></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </span>
          </a>
        </div>
      </li>
    </ul>
    <el-dialog title="修改密码" :visible.sync="dialogFormVisible" :show-close="false" @close="clearEditList('editPwdForm')" style="margin-top: 0px; left: 0px; z-index: 2154" class="logindialog" width="500px">
      <el-form ref="editPwdForm" :rules="rules" label-width="100px" :model="editPwdForm">
        <el-form-item label="登录密码" prop="password" class="is-required">
          <el-input size="medium" v-model.trim="editPwdForm.password" prefix-icon="el-icon-key" clearable placeholder="请输入登录密码"></el-input>
        </el-form-item>
        <el-form-item label="重复密码" prop="repeatPassword" class="is-required">
          <el-input size="medium" v-model.trim="editPwdForm.repeatPassword" prefix-icon="el-icon-key" clearable placeholder="请重复登录密码"></el-input>
        </el-form-item>
        <!-- <el-form-item style="margin-top:40px">
                    <el-button size="medium" @click="dialogFormVisible = false">取 消</el-button>
                <el-button size="medium" type="primary" :loading="loading" :disabled="disabled" @click="onSubmit">确 定</el-button>
            </el-form-item> -->
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="dialogFormVisible = false">取 消</el-button>
        <el-button size="medium" type="primary" :loading="loading" :disabled="disabled" @click="onSubmit()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 强制修改密码 -->
    <el-dialog title="修改密码" :visible.sync="dialogFormhandVisible" :show-close="false" :before-close="handleClose" @close="clearEditList('editPwdForm')" style="margin-top: 0px; left: 0px; z-index: 2154" class="logindialog" width="500px">
      <el-form ref="editPwdForm" :rules="rules" label-width="100px" :model="editPwdForm">
        <el-form-item label="登录密码" prop="password" class="is-required">
          <el-input size="medium" v-model.trim="editPwdForm.password" prefix-icon="el-icon-key" clearable placeholder="请输入登录密码"></el-input>
        </el-form-item>
        <el-form-item label="重复密码" prop="repeatPassword" class="is-required">
          <el-input size="medium" v-model.trim="editPwdForm.repeatPassword" prefix-icon="el-icon-key" clearable placeholder="请重复登录密码"></el-input>
        </el-form-item>
        <!-- <el-form-item style="margin-top:40px">
                    <el-button size="medium" @click="dialogFormVisible = false">取 消</el-button>
                <el-button size="medium" type="primary" :loading="loading" :disabled="disabled" @click="onSubmit">确 定</el-button>
            </el-form-item> -->
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="dialogFormVisible = false">取 消</el-button>
        <el-button size="medium" type="primary" :loading="loading" :disabled="disabled" @click="onSubmit()">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="完善信息" :visible.sync="dialogCompleteVisible" :show-close="false" :before-close="handleClose" @close="clearEditInfoList('editInfo')" style="margin-top: 0px" class="logindialog" width="500px">
      <el-form ref="editInfo" :rules="inforules" label-width="100px" :model="editInfo">
        <el-form-item label="真实姓名" prop="admin_name" class="is-required">
          <el-input size="medium" v-model.trim="editInfo.admin_name" placeholder="请输入真实姓名"></el-input>
        </el-form-item>
        <el-form-item label="手机号码" prop="admin_mobile_tel" class="is-required">
          <el-input size="medium" v-model.trim="editInfo.admin_mobile_tel" placeholder="请输入手机号码"></el-input>
        </el-form-item>
        <el-form-item label="身份证号" prop="admin_idcard_number" class="is-required">
          <el-input size="medium" v-model.trim="editInfo.admin_idcard_number" autocomplete="new-password" placeholder="请输入身份证号"></el-input>
        </el-form-item>
        <el-form-item label="登录密码" prop="login_pwd" class="is-required">
          <el-input size="medium" v-model.trim="editInfo.login_pwd" prefix-icon="el-icon-key" clearable autocomplete="new-password" placeholder="请输入登录密码"></el-input>
        </el-form-item>
        <el-form-item label="重复密码" prop="repeat_login_pwd" class="is-required">
          <el-input size="medium" v-model.trim="editInfo.repeat_login_pwd" prefix-icon="el-icon-key" clearable autocomplete="new-password" placeholder="请重复登录密码"></el-input>
        </el-form-item>
        <!-- <el-form-item style="margin-top:40px">
                    <el-button size="medium" @click="dialogFormVisible = false">取 消</el-button>
                <el-button size="medium" type="primary" :loading="loading" :disabled="disabled" @click="onSubmit">确 定</el-button>
            </el-form-item> -->
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button size="medium" type="primary" :loading="loading" :disabled="disabled" @click="onComplete">确 定</el-button>
      </div>
    </el-dialog>
    <div>
      <!-- <el-menu
                class="el-menu-vertical-demo"
                background-color="transparent"
                text-color="#a7b1c2"
                active-text-color="#fff"
                :unique-opened=true
                :router=true
                :default-active="$store.getters.activeTabName"
                @select="handelSelect"
               >
                <el-submenu v-for="(menu,i) in menulist" :key="menu.menuID" :index="i+''">
                    <template slot="title">
                        <i :class="menu.menuIcon"></i>
                        <span>{{menu.menuName}}</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item v-for="submenu in menu.subMenu" :key="submenu.menuID" :index="submenu.menuURL" :route="{path:submenu.menuURL}"><i :class="submenu.menuIcon"></i>{{ submenu.menuName }}</el-menu-item>
                    </el-menu-item-group>
                </el-submenu>
            </el-menu> -->
      <el-menu class="el-menu-vertical-demo" :collapse="!sidebar.opened" background-color="transparent" text-color="#a7b1c2" active-text-color="#fff" :unique-opened="true" :router="true" :default-active="$store.getters.activeTabName" @select="handelSelect" :collapse-transition="false">
        <el-submenu v-for="(menu, i) in menulist" :key="menu.menuID" :index="i + ''">
          <template slot="title">
            <i :class="menu.menuIcon"></i>
            <span>{{ menu.menuName }}</span>
          </template>

          <el-menu-item-group v-if="menu.rankindex == 2">
            <el-menu-item v-for="submenu in menu.subMenu" :key="submenu.menuID" :index="submenu.menuURL" :route="{ path: submenu.menuURL }">
              <template slot="title">
                <i :class="submenu.menuIcon"></i>
                <span>{{ submenu.menuName }}</span>
              </template>
            </el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-if="menu.rankindex == 3">
            <el-submenu v-for="(a, b) in menu.subMenu" :key="a.menuID" :index="b + '1'" style="background-color:#2f4050">
              <template slot="title">
                <i :class="a.menuIcon"></i>
                <span>{{ a.menuName }}</span></template>
              <el-menu-item-group>
                <el-menu-item v-for="m in a.subMenu" :key="m.menuID" :index="m.menuURL" :route="{ path: m.menuURL }">
                  <template slot="title">
                    <i :class="m.menuIcon"></i>
                    <span>{{ m.menuName }}</span>
                  </template>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
          </el-menu-item-group>
        </el-submenu>
      </el-menu>
    </div>
  </div>
</template>
<script>
import { adminModule, secondRoleModule } from "@/request/admin.js";
import router from "@/router.js";
import { baseconfig } from "@/config.js";
import store from "@/store";
import { mapState } from "vuex";
export default {
  data() {
    var validatecard = (rule, value, callback) => {
      if (value != "") {
        // var regex = /^(?!([a-zA-Z]+|\d+)$)[a-zA-Z\d]{8,16}$/
        var regex = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
        if (regex.test(value)) {
          callback();
        } else {
          callback(new Error("请输入正确的身份证号"));
        }
      }
    };
    var validatetel = (rule, value, callback) => {
      if (value != "") {
        // var regex = /^(?!([a-zA-Z]+|\d+)$)[a-zA-Z\d]{8,16}$/
        var regex = /^1[3456789]\d{9}$/;
        if (regex.test(value)) {
          callback();
        } else {
          callback(new Error("请输入正确的手机号"));
        }
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        var regex = /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[~!@#$%^&*-]).{8,20}$/;
        if (regex.test(value)) {
          callback();
        } else {
          callback(
            new Error(
              "请输入8~20位包含字母、数字、特殊符号（~!@#$%^&*-）的密码"
            )
          );
        }
      }
    };
    var validateRepeatPass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请确认密码"));
      } else {
        var regex = /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[~!@#$%^&*-]).{8,20}$/;
        if (regex.test(value)) {
          if (value === this.editPwdForm.password) {
            callback();
          } else {
            callback(new Error("两次输入的密码不一致"));
          }
        } else {
          callback(
            new Error(
              "请输入8~20位包含字母、数字、特殊符号（~!@#$%^&*-）的密码"
            )
          );
        }
      }
    };
    var validateCallPassword = (rule, value, callback) => {
      if (this.errors.password) {
        callback(new Error(this.errors.password));
      } else {
        callback();
      }
    };
    var validateCallRepeatPassword = (rule, value, callback) => {
      if (this.errors.repeatPassword) {
        callback(new Error(this.errors.repeatPassword));
      } else {
        callback();
      }
    };

    var validateinfoPass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        var regex = /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[~!@#$%^&*-]).{8,20}$/;
        if (regex.test(value)) {
          callback();
        } else {
          callback(
            new Error(
              "请输入8~20位包含字母、数字、特殊符号（~!@#$%^&*-）的密码"
            )
          );
        }
      }
    };
    var validateinfoRepeatPass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请确认密码"));
      } else {
        var regex = /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[~!@#$%^&*-]).{8,20}$/;
        if (regex.test(value)) {
          if (value === this.editInfo.login_pwd) {
            callback();
          } else {
            callback(new Error("两次输入的密码不一致"));
          }
        } else {
          callback(
            new Error(
              "请输入8~20位包含字母、数字、特殊符号（~!@#$%^&*-）的密码"
            )
          );
        }
      }
    };
    var validateCallinfoPassword = (rule, value, callback) => {
      if (this.infoerrors.login_pwd) {
        callback(new Error(this.errors.login_pwd));
      } else {
        callback();
      }
    };
    var validateCallinfoRepeatPassword = (rule, value, callback) => {
      if (this.errors.repeat_login_pwd) {
        callback(new Error(this.errors.repeat_login_pwd));
      } else {
        callback();
      }
    };
    return {
      adminUnitName: "",
      isshowclose: true,
      loading: false,
      disabled: false,
      menulist: [],
      adminName: "",
      adminRoleName: "",
      dialogFormVisible: false,
      dialogFormhandVisible: false,
      dialogCompleteVisible: false,
      editInfo: {
        admin_name: "",
        admin_mobile_tel: "",
        admin_idcard_number: "",
        login_pwd: "",
        repeat_login_pwd: "",
      },
      infoerrors: {
        login_pwd: "",
        repeat_login_pwd: "",
      },
      editPwdForm: {
        password: "",
        repeatPassword: "",
      },
      errors: {
        password: "",
        repeatPassword: "",
      },
      rules: {
        password: [
          { validator: validatePass, trigger: "blur" },
          { validator: validateCallPassword },
        ],
        repeatPassword: [
          { validator: validateRepeatPass, trigger: "blur" },
          { validator: validateCallRepeatPassword },
        ],
      },
      inforules: {
        admin_name: [
          { required: true, message: "请输入真实姓名", trigger: "blur" },
        ],
        login_pwd: [
          { validator: validateinfoPass, trigger: "blur" },
          { validator: validateCallinfoPassword },
        ],
        repeat_login_pwd: [
          { validator: validateinfoRepeatPass, trigger: "blur" },
          { validator: validateCallinfoRepeatPassword },
        ],
        admin_mobile_tel: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          { validator: validatetel },
        ],
        admin_idcard_number: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
          { validator: validatecard },
        ],
      },
    };
  },
  created: async function () {
    await this.getMenuList();
    console.log(store.getters.isNeedComplate);
    if (store.getters.isNeedComplate == 1) {
      this.dialogCompleteVisible = true;
    }
    if (store.getters.isNeedComplate == 0) {
      if (store.getters.isNeedEditPwd == 1) {
        this.dialogFormhandVisible = true;
      }
    }

    await this.getLoginAdmin();
    await this.biztimesetgetyear();
  },
  computed: {
    scrollerHeight: function () {
      return window.innerHeight + "px";
    },

    ...mapState({
      sidebar: (state) => state.app.sidebar,
      device: (state) => state.app.device,
    }),
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === "mobile",
      };
    },
  },
  methods: {
    handleClose(done) {
      // this.dialogCompleteVisible= true
    },

    async getMenuList() {
      // await adminModule.getRoleMenuList().then((response) => {
      // console.log('list',response)
      //     switch(response.data.code){
      //         case 100 :

      //             this.menulist=response.data.result
      //             break;
      //         case 101:
      //             break;
      //         case 102:
      //             this.$message.error(response.data.message);
      //             router.push('login')
      //             break;
      //         default:
      //             // this.$message.error(response.data.message);
      //         break;
      //     }

      // }).catch(function (error) {

      // })
      await secondRoleModule
        .getRoleMenuListThree()
        .then((response) => {
          console.log("list", response);
          switch (response.data.code) {
            case 100:
              this.menulist = response.data.result;
              this.menulist = response.data.result;
              this.menulist.forEach((obj, index) => {
                if (obj.menuURL == "~") {
                  obj.subMenu.forEach((e, i) => {
                    if (e.menuURL == "~") {
                      this.menulist[index].rankindex = 3;
                    } else {
                      this.menulist[index].rankindex = 2;
                    }
                  });
                }
              });
              break;
            case 101:
              break;
            case 102:
              this.$message.error(response.data.message);
              router.push("login");
              break;
            default:
              // this.$message.error(response.data.message);
              break;
          }
        })
        .catch(function (error) { });
    },
    // 获取用户信息
    async getLoginAdmin() {
      await adminModule
        .newadminlogininfo()
        .then((response) => {
          console.log("admin", response);
          switch (response.data.code) {
            case 100:
              this.adminName = response.data.result.adminName;
              this.adminRoleName = response.data.result.roleName;
              this.adminUnitName = response.data.result.adminUnitName;
              this.$store.dispatch(
                "admin/setAdminRegionLevel",
                response.data.result.adminRegionLevel
              );
              this.$store.dispatch(
                "admin/setAdminRegionLevelName",
                response.data.result.adminRegionLevelName
              );
              this.$store.dispatch(
                "admin/setAdminRegionID",
                response.data.result.adminRegionID
              );
              break;
            case 101:
              break;
            case 102:
              this.$message.error(response.data.message);
              router.push("login");
              break;
            default:
              // this.$message.error(response.data.message);
              break;
          }
        })
        .catch(function (error) { });
    },
    handelSelect(key, keyPath) {
      for (var firstLevelMenu of this.menulist) {
        for (var secondLevelMenu of firstLevelMenu.subMenu) {
          if (secondLevelMenu.menuURL == key) {
            var newTab = {
              taburl: secondLevelMenu.menuURL,
              tabicon: secondLevelMenu.menuIcon,
              tabtitle: secondLevelMenu.menuName,
            };
            this.$store.dispatch("tab/addTab", newTab);
            return;
          } else {
            for (var sthirdlyLevelMenu of secondLevelMenu.subMenu) {
              if (sthirdlyLevelMenu.menuURL === key) {
                var newTabs = {
                  taburl: sthirdlyLevelMenu.menuURL,
                  tabicon: sthirdlyLevelMenu.menuIcon,
                  tabtitle: sthirdlyLevelMenu.menuName,
                };
                this.$store.dispatch("tab/addTab", newTabs);
                return;
              }
            }
          }
        }
      }
    },
    clearEditList(editPwdForm) {
      this.$refs[editPwdForm].resetFields();
      console.log("sdhkas");
      this.editPwdForm.password = "";
      this.editPwdForm.repeatPassword = "";
      this.$forceUpdate();
    },
    clearEditInfoList(editInfo) {
      this.$refs[editInfo].resetFields();
      console.log("sdhkas");
      this.editInfo.admin_name = "";
      this.editInfo.admin_mobile_tel = "";
      this.editInfo.admin_idcard_number = "";
      this.editInfo.login_pwd = "";
      this.editInfo.repeat_login_pwd = "";
      this.$forceUpdate();
    },
    logOut() {
      this.$store.dispatch("admin/removeAdminID");
      this.$store.dispatch("admin/removeToken");
      router.replace("login");
    },
    // 完善信息
    async onComplete() {
      this.$refs.editInfo.validate(async (valid) => {
        if (valid) {
          await adminModule
            .complateadmininfo(
              this.editInfo.admin_name,
              this.editInfo.admin_mobile_tel,
              this.editInfo.admin_idcard_number,
              this.editInfo.login_pwd,
              this.editInfo.repeat_login_pwd
            )
            .then((response) => {
              switch (response.data.code) {
                case 100:
                  {
                    console.log("sdsdsdsds");
                    this.dialogCompleteVisible = false;
                    this.$store.dispatch("admin/setIsNeedComplate", 0);
                    const h = this.$createElement;
                    this.$notify({
                      title: "成功",
                      message: h("span", "完善成功,请重新登录"),
                      type: "success",
                    });
                    this.logOut();
                    // this.$message({message: '添加成功',type: 'success'});
                  }
                  break;
                case 100002:
                  this.$message.error(baseconfig.no_permission_message);
                  break;
                default:
                  this.$message.error(response.data.message);
                  break;
              }
            })
            .catch(function (error) { });
        }
      });
    },
    // 修改密码
    async onSubmit() {
      this.$refs.editPwdForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.disabled = true;
          adminModule
            .editLoginAdminPwd(
              this.editPwdForm.password,
              this.editPwdForm.repeatPassword
            )
            .then((response) => {
              this.loading = false;
              this.disabled = false;
              switch (response.data.code) {
                case 100:
                  {
                    const h = this.$createElement;
                    this.$notify({
                      title: "成功",
                      message: h("span", "修改密码成功,请重新登录"),
                      type: "success",
                    });
                    this.dialogFormVisible = false;
                    this.editPwdForm.password = "";
                    this.editPwdForm.repeatPassword = "";
                    this.logOut();
                  }

                  break;
                case 100002:
                  this.$message.error(baseconfig.no_permission_message);
                  break;
                default:
                  this.$message.error(response.data.message);
                  break;
              }
            })
            .catch(function (error) { });
        } else {
          return false;
        }
      });
    },
    /**
     * 2023-11-1 获取开始当前年份
     */
    async biztimesetgetyear() {
      await adminModule.biztimesetgetyear().then((response) => {
        switch (response.data.code) {
          case 100:
            this.$store.dispatch(
              "admin/setCurrentApplicationYear",
              response.data.result
            );
            break;
          case 100002:
            break;
          default:
            break;
        }
      })
        .catch(function (error) {
          console.log(error);
        });

    },

  },
};
</script>
<style scoped>
.headdiv {
  width: 100px;
  height: 100px;
  margin: 0 auto;
  margin-top: 30px;
  line-height: 100px;
}
.cleardiv {
  clear: both;
}

.navscroll {
  overflow-y: scroll;
}
.navscroll::-webkit-scrollbar {
  display: none;
  /* Chrome Safari */
}

.navscroll {
  scrollbar-width: none;
  /* firefox */
  -ms-overflow-style: none;
  /* IE 10+ */
  overflow-x: hidden;
  overflow-y: auto;
}

.el-dropdown-link {
  cursor: pointer;
  color: #8095a8;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.el-menu {
  border-right: 0;
  padding: 0;
  background: #2f4050;
}
.el-menu-item {
  background-color: #293846 !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.el-menu >>> .el-menu-item-group__title {
  padding: 0;
  line-height: 0;
  font-size: 0;
  color: #909399;
}

/* .el-menu-item:hover{
        outline: 0 !important;
        color: #a7b1c2 !important;
    } */
.el-menu-item .is-active {
  color: #fff !important;
  /* background: #409EFF !important; */
}

.el-submenu >>> .el-submenu__title:focus,
.el-submenu >>> .el-submenu__title:hover {
  outline: 0 !important;
  /* color: #409EFF !important; */
  background: #293846 !important;
}
.el-menu .is-opened >>> .el-submenu__title {
  color: #fff !important;
  background: #293846 !important;
}
.el-menu .is-opened >>> i {
  color: #fff !important;
  background: #293846 !important;
}
.logindialog {
  top: 0px;
  background-color: rgba(10, 4, 4, 0.4);
  padding-top: 15vh;
  z-index: 3000 !important;
}
.logindialog >>> .el-input {
  width: 300px;
}
.logindialog >>> .el-dialog {
  border-radius: 8px;
}
.logindialog >>> .el-dialog__close {
  position: absolute;
  top: -20px;
  right: 0px;
  padding: 0;
  background: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  font-size: 16px;
  font-size: 23px !important;
}
.logindialog >>> .el-dialog__header {
  position: inherit;
  width: inherit;
  box-sizing: border-box;
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;
}
.logindialog >>> .el-dialog__footer {
  padding: 20px 30px;
  text-align: right;
  box-sizing: border-box;
  border-top: 1px solid #f0f0f0;
}
.logindialog >>> .el-dialog__body {
  padding-top: 30px;
}
.logindialog >>> .el-dialog__close {
  top: -15px;
}
</style>
